(function($) {
  var iframe = $('#video-capsule');

  if (iframe) {
    // Stop/reset video when close modal
    $('#modal-capsule').on('hidden.bs.modal', function() {
      var video_src = iframe.attr('src');
      iframe.attr('src',''); 
      iframe.attr('src', video_src);
    });
  }
})(jQuery);
